// extracted by mini-css-extract-plugin
export default {"container":"NavigateMenu_container__IaA+c","wrapperPill":"NavigateMenu_wrapperPill__Nku-4"};